module.exports = __webpack_public_path__ + "img/CNT.671be58c.png";